import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../Datas/productData";
import "../css/about.scss";

function About() {
  return (
    <main className="about" aria-labelledby="about-title">
      <section className="about__hero">
        <p className="about__eyebrow">The house / Paris</p>
        <div className="about__hero-grid">
          <h1 id="about-title">A new gesture for the neck.</h1>
          <div className="about__introduction">
            <p>{siteConfig.description}</p>
            <p>
              {siteConfig.brandName} began with a simple conviction: a formal
              accessory can feel considered, expressive and entirely natural
              to wear.
            </p>
          </div>
        </div>
      </section>

      <figure className="about__figure about__figure--wide">
        <img
          src="/main/founders-studio.jpg"
          alt={`${siteConfig.brandName} founders working together in their studio`}
          loading="eager"
          decoding="async"
        />
        <figcaption>Paris — the studio, the conversations, the first forms.</figcaption>
      </figure>

      <section className="about__manifesto" aria-labelledby="manifesto-title">
        <p className="about__eyebrow about__eyebrow--light">01 / Our approach</p>
        <div className="about__manifesto-grid">
          <h2 id="manifesto-title">Less, but with more feeling.</h2>
          <div className="about__copy">
            <p>
              We begin with proportion, touch and the way cloth falls at the
              collar. Every fold has a purpose; every material is chosen for
              how it catches light, moves and becomes familiar over time.
            </p>
            <p>
              Collections are intentionally concise. We work at a measured
              pace, refining each piece through drawings, samples and hands-on
              testing before it earns a place in the collection.
            </p>
          </div>
        </div>
      </section>

      <section className="about__atelier" aria-labelledby="atelier-title">
        <figure className="about__figure about__figure--portrait">
          <img
            src="/main/atelier-craft.jpg"
            alt={`A craftsperson finishing a ${siteConfig.brandName} piece by hand`}
            loading="lazy"
            decoding="async"
          />
          <figcaption>Material, gesture, time.</figcaption>
        </figure>

        <div className="about__atelier-copy">
          <p className="about__eyebrow">02 / The atelier</p>
          <h2 id="atelier-title">A dialogue between hand and material.</h2>
          <p>
            Our process brings contemporary design into conversation with
            enduring craft. Small variations are not concealed: they are the
            trace of a maker, and part of what gives each piece its character.
          </p>
          <dl className="about__principles">
            <div>
              <dt>01</dt>
              <dd>Purposeful materials</dd>
            </div>
            <div>
              <dt>02</dt>
              <dd>Measured production</dd>
            </div>
            <div>
              <dt>03</dt>
              <dd>Made to be worn</dd>
            </div>
          </dl>
        </div>
      </section>

      <section className="about__closing" aria-labelledby="about-closing-title">
        <p className="about__eyebrow">The collection</p>
        <h2 id="about-closing-title">A final gesture that makes the look your own.</h2>
        <div className="about__actions">
          <Link className="about__link about__link--primary" to="/shop">
            Discover the collection
            <span aria-hidden="true">↗</span>
          </Link>
          <Link className="about__link" to="/contact">
            Speak with the studio
            <span aria-hidden="true">↗</span>
          </Link>
        </div>
      </section>
    </main>
  );
}

export default About;
